import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { AddUserComponent } from 'src/app/components/snackbars/add-user/add-user.component';
import { BackendListModel } from 'src/app/models/common/list.model';
import { RegionModel } from 'src/app/models/common/region';
import { UserRole, USER_ROLE_TYPE_INTERNAL } from 'src/app/models/common/user-role';
import { UserModel } from 'src/app/models/common/usermodel';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { AuthService } from 'src/app/services/auth.service';
import { GeoApiService } from 'src/app/services/domain_code/geo-api.service';
import { UserMasterApiService } from 'src/app/services/domain_code/user-master-api.service';


@Component({
    selector: 'logzy-user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.scss',
        '../master-data.scss']
})
export class UserFormComponent implements OnInit {

    department_url = `${ApiRoutes.Company}department/`;
    user_url = `${ApiRoutes.Company}user_list/`;
    region_url = `${ApiRoutes.Geo}region/`;
    role_url = `${ApiRoutes.Company}profile_role/?type=${USER_ROLE_TYPE_INTERNAL}&search=::search::`;

    open: string = "sidepanel";
    Canvas: string = "Canvas";

    @Input()
    isEditable: boolean = true;

    @Input()
    userObject: UserModel;

    @Input()
    errorObj: any = {};

    @Output()
    closeForm = new EventEmitter<UserModel>();

    keysToTransform = [
        'department',
        'manager',
        'role',
        'region',
        'picture'
    ];

    setCanvas(canvasData: any) {
        this.Canvas = canvasData;
    }

    addUser(className: string) {
        this.snackBar.openFromComponent(AddUserComponent, {
            duration: 2000,
            panelClass: [className]
        });
    }
    constructor(private snackBar: MatSnackBar,
        private userService: UserMasterApiService,
        private geoService: GeoApiService,
        private authService: AuthService) { }

    defaultUserObj: UserModel = {
        id: null,
        role: null,
        designation: null,
        manager: null,
        first_name: null,
        last_name: null,
        email: null,
        department: null,
        cover_picture: null,
        linked_in_profile: null,
        e_sign: null,
        picture: null,
        region: null,
        theme: 'default',
        created_at: null,
        updated_at: null,
        created_by: null,
        updated_by: null,
        is_active: true,
        mobile_number: null,
        whatsapp_number: null,
        gender: 'Other',
        date_of_birth: null,
        anniversary_date: null,
        external_profile_id: null,
    }

    ngOnInit(): void {
        this.resetComponent();
        this.getAllRegionList();
    }

    resetComponent() {
        this.errorObj = {};
        this.userObject = { ...this.defaultUserObj };
    }

    userRole_list: BackendListModel<UserRole>
    region_list: BackendListModel<RegionModel>

    // GET region list to filter w.r.t isd_code of mobile_number field
    getAllRegionList() {
        this.geoService.getRegion().subscribe({
            next: response => {
                this.region_list = response;
            },
            error: error => {
                console.log(error);
                return error;
            }
        });
    }

    getSingleRegion(id: string) {
        this.geoService.getRegionById(id).subscribe({
            next: response => {
                this.userObject.region = JSON.parse(JSON.stringify(response));
            },
            error: error => {
                console.log(error);
                return error;
            }
        });
    }

    getRegionByIsdCode(item) {
        if (!this.userObject.id) {
            if (item == null) {
                this.userObject.region = null;
                return;
            }

            let countryId = item.id
            let filteredRegion;
            for (let i = 0; i < this.region_list.results.length; i++) {
                for (let j = 0; j < this.region_list.results[i].countries.length; j++) {
                    if (countryId == this.region_list.results[i].countries[j]['id']) {
                        filteredRegion = this.region_list.results[i]
                    }
                }
            }
            if (filteredRegion != null && filteredRegion != undefined) {
                this.getSingleRegion(filteredRegion.id);
            } else {
                this.userObject.region = null;
            }
        }
    }

    // Function to catch errors
    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = { ...error.error };
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = { ...error.error };
            return error;
        }
    }

    postUserData(data) {
        this.userService.postUser(data).subscribe({
            next: response => {
                this.snackBar.open("User Added Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.closeUserForm(response);
                return response;
            },
            error: error => {
                return this.catchError(error);
            }
        });
    }

    putUserData(id, data) {
        this.userService.updateUser(id, data).subscribe({
            next: response => {
                this.snackBar.open("User Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.closeUserForm(response);
                return response;
            },
            error: error => {
                return this.catchError(error);
            }
        });
    }

    filterUserData() {
        let data = { ...this.userObject }

        for (const key of this.keysToTransform) {
            if (data[key] != null && data[key] != '')
                data[key] = data[key].id;
        }
        return data;
    }

    onUserSave() {
        if (this.isEditable == true) {
            let payload = this.filterUserData();

            if (payload.id != null) {
                this.putUserData(payload.id, payload);
            } else {
                this.postUserData(payload);
            }
        } else {
            this.isEditable = true
        }
    }

    closeUserForm(userObject: any) {
        this.resetComponent();
        this.closeForm.emit(userObject);
    }
}
